module.exports = __webpack_public_path__ + "d4.no2.bfe74553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d4.no2.jpg
// module id = Zq59
// module chunks = 0